import barba from '@barba/core';
import { initializeComponents } from '../index.js';
import { loadHubspotFormIfPresent } from '../index.js';
import gsap from 'gsap';

/**
 * Initialize Barba.js for page transitions
 */
export const initializeBarba = () => {
	// Verify Barba wrapper exists
	const barbaWrapper = document.querySelector('[data-barba="wrapper"]');
	if (!barbaWrapper) {
		console.error('Barba.js: No wrapper element found. Please add a div with data-barba="wrapper" attribute to your HTML.');
		return;
	}

	// Store the scroll position before transition
	let scrollPosition = 0;
	let loadingIndicator;

	// Create loading indicator
	const createLoadingIndicator = () => {
		const mainContent = document.querySelector('main');
		if (mainContent) {
			loadingIndicator = document.createElement('div');
			loadingIndicator.className = 'loading-indicator';
			mainContent.appendChild(loadingIndicator);
		}
	};

	// Remove loading indicator
	const removeLoadingIndicator = () => {
		if (loadingIndicator) {
			loadingIndicator.remove();
			loadingIndicator = null;
		}
	};

	barba.init({
		// Prevent click when transition is running
		preventRunning: true,

		// Timeout for transitions (in milliseconds)
		timeout: 5000,

		// Define transitions
		transitions: [
			{
				name: 'default-transition',
				sync: true,
				beforeLeave(data) {
					// Store scroll position
					scrollPosition = window.scrollY;
					createLoadingIndicator();
				},
				leave(data) {
					// Fade out current page
					return gsap.to(data.current.container, {
						opacity: 0,
						duration: 0.4,
						ease: 'power2.inOut',
					});
				},
				enter(data) {
					// Reset scroll position
					window.scrollTo(0, 0);

					// Fade in new page
					return gsap.from(data.next.container, {
						opacity: 0,
						duration: 0.4,
						ease: 'power2.inOut',
					});
				},
				afterEnter(data) {
					// Initialize components on the new page with a small delay
					setTimeout(() => {
						initializeComponents();
						// Refresh AOS to ensure it picks up new elements
						if (typeof AOS !== 'undefined') {
							AOS.refresh();
						}
						removeLoadingIndicator();
						loadHubspotFormIfPresent();
					}, 100);
				},
			},
		],

		// Views
		views: [],

		// Hooks
		hooks: {
			beforeEnter: () => {
				// Add loading state class to body
				document.body.classList.add('is-transitioning');
			},
			afterEnter: () => {
				// Remove loading state class from body
				document.body.classList.remove('is-transitioning');
				loadHubspotFormIfPresent();
			},
		},
	});
};
